import { AbilitiesManager } from './abilities-manager';

let abilitiesManagerSingleton: AbilitiesManager;

export const getAbilitiesManager = () => {
  if (!abilitiesManagerSingleton) {
    abilitiesManagerSingleton = new AbilitiesManager();
  }

  return abilitiesManagerSingleton;
};
